export const accessConsultantUrl = (consultantNumber: string) =>
  `/system/ajax/VipShopping/AccessConsultant?consultantNumber=${consultantNumber}`;

export const basketUrl = '/shopping/basket';

export const getConsultantNumbersUrl = (hint: string) =>
  `/system/ajax/VipShopping/GetConsultantNumbers?hint=${hint}`;

export const vipAccessUrl = '/system/ajax/stickybar/VipAccessJson';

export const vipAccessSwitchUrl = (consultantNumber: number) =>
  `/system/ajax/StickyBar/VipAccessSwitch?ConsultantNumber=${consultantNumber}`;

export const vipAccessSwitchValidateUrl = (consultantNumber: string) =>
  `/system/ajax/StickyBar/VipAccessSwitchValidate?ajaxId=69&related%5BConsultantNumber%5D=${consultantNumber}&activeInput=ConsultantNumber&ConsultantNumber=${consultantNumber}`;
